import { EntityType } from '@lib/content';
import { C3AddFormEntity } from './types';

export const toForm = (data: any): C3AddFormEntity => {
   const contentdata =
      data?.contents && data?.contents.length > 0
        ? data?.contents.map(x => ({
            name: x.name || x.title || x.original_title,
            vtr_id: x.vtr_id,
            type: EntityType.content,
            meta: null,
          }))
        : [
            {
              vtr_id: '',
              type: EntityType.content,
              name: '',
              meta: null,
            },
          ];
  return {
    contents: contentdata || [],
    /*  contents: data.contents.vtr_id
          ? {
              vtr_id: data?.content.vtr_id,
              type: EntityType.content,
              name: data?.content.title || data?.content.original_title,
              meta: null,
            }
          : {
              vtr_id: '',
              type: EntityType.content,
              name: '',
              meta: null,
            },  */
    associated_person: data.associated_person || [],
    source_urls:data.source_urls ||[],
    source:data.source || "Vitrina"
  };
};

export const fromForm = (formData: C3AddFormEntity): any => {
  return {
    contents: formData.contents || [],
    associated_person: formData.associated_person || [],
    source_urls:formData.source_urls ||[],
        source:formData.source || "Vitrina"
  };
}; 